/**
 * Global hayvan modu — KÖPEK-3.
 *
 * Kullanıcı header'daki markaya (StrayPaw) dokununca Kedi / Köpek / Hepsi
 * seçer. Seçim TÜM uygulamayı süzer: kedi ızgarası, /sightings, harita, şerit.
 *
 * Değerler: "cats" | "dogs" | "all".  Varsayılan "all" (StrayPaw'da her şey).
 *
 * Backend `?animal` filtresi (KÖPEK-1) "cat" | "dog" bekler; `animalParam`
 * "all" → undefined (filtre yok) çevirir.
 *
 * TUR-4 (28 Ağu 2026) — TÜRKİYE'DE SÜZGEÇ KOŞULSUZ "cat".
 *
 * Buradaki eski yorum şöyle diyordu: "Türkiye'de köpek kavramı gizli olduğundan
 * toggle hiç gösterilmez; mod 'all' kalır VE KÖPEK VERİSİ DE OLMADIĞINDAN
 * pratikte yalnızca kedi görünür."
 *
 * O varsayım 28 Ağustos'ta çöktü. E-0 düzeltilmeden önce kaydedilen bir Bali
 * köpeği Türkiye veritabanına düştü ve sokakkedileri.tr'nin "Kedi Veritabanı"
 * sayfasında ilk kart olarak göründü. Sayaç da bozuldu: sayfa 134 (liste
 * uzunluğu), backend 133 (tür ayıran sayım) diyordu.
 *
 * Ders: "veri yok" bir süzgeç değildir. Türkiye'de köpek GÖSTERİLMEYECEKSE
 * bunu kod söylemeli, verinin yokluğu değil. Kayıt silinse bile kural kalır ve
 * bir dahaki yanlış yönlendirilmiş kayıt aynı yere düşmez.
 */
import { getCountry } from "./country";

const KEY = "sk_animal_mode";
const VALID = new Set(["cats", "dogs", "all"]);

export function getAnimalMode() {
  try {
    const v = localStorage.getItem(KEY);
    if (VALID.has(v)) return v;
  } catch {
    /* localStorage yoksa varsayılan */
  }
  return "all";
}

export function setAnimalMode(mode) {
  const m = VALID.has(mode) ? mode : "all";
  try {
    localStorage.setItem(KEY, m);
  } catch {
    /* yok say */
  }
  // Diğer bileşenler (liste/harita/şerit) taze veriyle yenilensin diye yayınla.
  try {
    window.dispatchEvent(new Event("sk-animal-mode"));
  } catch {
    /* SSR/test ortamı */
  }
  return m;
}

/**
 * API çağrılarına eklenecek ?animal değeri. "all" → undefined (filtre yok).
 *
 * TUR-4: Türkiye'de mod ne olursa olsun "cat" döner — köpek kavramı orada
 * gizli. Tek kapı: animalParam'ı çağıran her yer (liste, harita, kayıp şeridi,
 * ödül avcısı) bu kuralı kendiliğinden alır.
 */
export function animalParam(mode) {
  if (getCountry() === "tr") return "cat";
  const m = VALID.has(mode) ? mode : getAnimalMode();
  return m === "cats" ? "cat" : m === "dogs" ? "dog" : undefined;
}

/**
 * TUR-7 (29 Ağu 2026) — TÜRKİYE'DE KÖPEK KAVRAMI KAPALI. TEK KAPI.
 *
 * TUR-4 okuma yolunu (`animalParam`) kapattı: Türkiye'de listeler, harita ve
 * sayaçlar yalnızca kedi görüyor. Ama YAZMA ve ARAYÜZ yolları açık kalmıştı:
 *
 *  - Kayıt ekranlarında (KediProfiliOlustur, ScanCatProfileFinalize) "Köpek
 *    olarak kaydet" bağlantısı Türkiye'de de görünüyordu. Yani köpek kavramı
 *    Türkiye'de ekranda YAZILIYDI ve oradan Türkiye veritabanına köpek kaydı
 *    açılabiliyordu.
 *  - Kayıp/kimlik/tarama akışları türü ham moddan (`getAnimalMode`) okuyordu.
 *    Yurt dışında "dogs" seçip Türkiye'ye dönen bir cihazda localStorage'daki
 *    mod "dogs" kalıyor; sonraki kayıt Türkiye'de köpek olarak açılıyordu.
 *
 * Ders TUR-4'ün dersinin aynısı: bir kavramı gizlemek onu okumaktan çıkarmak
 * değildir — yazmaktan da, çizmekten de çıkarmaktır. Üç kapı da tek yerden
 * kilitleniyor: okuma `animalParam`, yazma `kayitTuru`, arayüz `kopekAcikMi`.
 */
export function kopekAcikMi() {
  try {
    return getCountry() !== "tr";
  } catch {
    return false;
  }
}

/** Yeni kaydın türü. Türkiye'de mod ne olursa olsun "cat". */
export function kayitTuru() {
  return kopekAcikMi() && getAnimalMode() === "dogs" ? "dog" : "cat";
}
